import { withStyles } from '@material-ui/core';
import PaymentOption from './PaymentOption';
import styles from './PaymentOption.styles';

export default withStyles(styles)(PaymentOption);
